try {
  if (new URLSearchParams(window.location.search).get('cookieAccept') === '1') {
    const style = document.createElement('style');
    style.textContent = '#termly-code-snippet-support, [id^="termly-"], .t-consentPrompt { display: none !important; }';
    document.head.appendChild(style);
  }
} catch (e) {
  // no-op
}
